import { Box, CardBorder } from 'components/elements'
import { AlertKeyEnums, IncidentEnums } from './enums'
import { CardCss, DetailContainer, DetailWrapper, InfoColumn, StyledTCard } from './style'
import { ScoreA, ScoreB, ScoreC, ScoreD } from 'components/icons'
import { addNumeral } from 'utils/function'

export type IncidentDetailProps = {
  title?: string
  fields: Record<string, string>
  hideBorder?: boolean
}

type CardDetailProps = {
  title?: string
  description?: string | number
}

type DetailData = {
  data: CardDetailProps
}
export const formatValue = (value: string) => {
  const date = new Date(value)
  const isValidDate = !isNaN(date.getTime())

  if (isValidDate && value?.includes('T') && value?.includes('Z')) {
    return date.toDateString() // or use date.toLocaleString() for more detail
  }

  return value
}

export const IncidentDetail = ({ title, fields, hideBorder = false }: IncidentDetailProps) => {
  const getTitle = (key: string) => {
    // Convert camelCase or PascalCase to space-separated
    const spaced = key.replace(/([a-z])([A-Z])/g, '$1 $2')

    // Replace underscores with spaces
    const modifiedTitle = spaced.replaceAll('_', ' ')

    // Capitalize the first letter
    return modifiedTitle.charAt(0).toUpperCase() + modifiedTitle.slice(1)
  }

  const renderClassName = (key: string) => {
    let className = ''
    if (key === AlertKeyEnums.CONFIDENCE_LEVEL) {
      className += 'transformation colorBox warningBg'
    }
    if (key === AlertKeyEnums.CLASSIFICATION) {
      className += 'transformation colorBox errorBg'
    }
    return className
  }

  return (
    <DetailWrapper css={{ borderTop: hideBorder ? 'none' : '1px solid $gray5' }}>
      <Box as="h2" css={{ mb: '1.5rem' }}>
        {title !== IncidentEnums.regOnChainStatus ? title : IncidentEnums.REG_ON_CHAIN_STATUS}
      </Box>
      <DetailContainer>
        {typeof fields !== 'string' ? (
          Object.keys(fields)
            .filter(key => key !== 'service')
            .map(key => {
              return (
                <InfoColumn key={key}>
                  <p className="t-key">{getTitle(key)}</p>
                  <p className={`t-value ${renderClassName(key)}`}>
                    {typeof fields[key] === 'string' ? formatValue(fields[key]) : typeof fields[key] === 'number' ? fields[key] : 'Not available'}
                  </p>
                </InfoColumn>
              )
            })
        ) : (
          <InfoColumn>
            <Box as="p" className="t-value">
              {fields || 'Not available'}
            </Box>
          </InfoColumn>
        )}
      </DetailContainer>
    </DetailWrapper>
  )
}

export const CardDetail = ({ data }: DetailData) => {
  const { title, description } = data

  const ScoreGrade = () => {
    if (Number(description) >= 85) {
      return <ScoreA />
    } else if (Number(description) >= 70 && Number(description) < 85) {
      return <ScoreB />
    } else if (Number(description) >= 55 && Number(description) < 70) {
      return <ScoreC />
    } else if (Number(description) >= 0 && Number(description) < 55) {
      return <ScoreD />
    } else {
      return <></>
    }
  }

  const DescriptionValue = () => {
    if (title === IncidentEnums.DESCRIPTION_AMOUNT) {
      return <>{`$ ${addNumeral(1000000)}`}</>
    } else {
      return <>{description}</>
    }
  }

  return (
    <CardBorder outerCss={CardCss}>
      <StyledTCard>
        <Box className="main-wrap">
          {title === IncidentEnums.RISK_SCORE && (
            <Box className="img-wrap">
              <ScoreGrade />
            </Box>
          )}
          <Box className="sub-wrap">
            <h3 className="title">{title}</h3>
            <h3 className="description">
              <DescriptionValue />
            </h3>
          </Box>
        </Box>
      </StyledTCard>
    </CardBorder>
  )
}
